import { render, staticRenderFns } from "./GodovojKursIspanskogoYazyka.vue?vue&type=template&id=15f3850e&scoped=true&"
import script from "./GodovojKursIspanskogoYazyka.vue?vue&type=script&lang=js&"
export * from "./GodovojKursIspanskogoYazyka.vue?vue&type=script&lang=js&"
import style0 from "./GodovojKursIspanskogoYazyka.vue?vue&type=style&index=0&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&lang=css&"
import style1 from "./GodovojKursIspanskogoYazyka.vue?vue&type=style&index=1&id=15f3850e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3850e",
  null
  
)

export default component.exports